/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Only provided for WebhookType==FaultedDeviceReport
 * @export
 * @interface FaultedDeviceReportMetadata
 */
export interface FaultedDeviceReportMetadata {
    /**
     * Report period
     * @type {string}
     * @memberof FaultedDeviceReportMetadata
     */
    period?: FaultedDeviceReportMetadataPeriodEnum;
}

/**
 * @export
 */
export const FaultedDeviceReportMetadataPeriodEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;
export type FaultedDeviceReportMetadataPeriodEnum =
    (typeof FaultedDeviceReportMetadataPeriodEnum)[keyof typeof FaultedDeviceReportMetadataPeriodEnum];

/**
 * Check if a given object implements the FaultedDeviceReportMetadata interface.
 */
export function instanceOfFaultedDeviceReportMetadata(
    value: object,
): value is FaultedDeviceReportMetadata {
    return true;
}

export function FaultedDeviceReportMetadataFromJSON(
    json: any,
): FaultedDeviceReportMetadata {
    return FaultedDeviceReportMetadataFromJSONTyped(json, false);
}

export function FaultedDeviceReportMetadataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): FaultedDeviceReportMetadata {
    if (json == null) {
        return json;
    }
    return {
        period: json["period"] == null ? undefined : json["period"],
    };
}

export function FaultedDeviceReportMetadataToJSON(
    value?: FaultedDeviceReportMetadata | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        period: value["period"],
    };
}
